/**
 * API Configuration
 * Smart detection: uses /api for production (proxied by Kubernetes Ingress)
 * or full backend URL for local development
 */

// Detect if we're in local development environment
const isLocalDev = typeof window !== 'undefined' && 
                   (window.location.hostname === 'localhost' || 
                    window.location.hostname === '127.0.0.1');

// Detect if we're in preview/staging environment (emergentagent.com domains)
const isPreview = typeof window !== 'undefined' && 
                  window.location.hostname.includes('emergentagent.com');

// Get API base URL with smart detection
export const API_BASE_URL = (() => {
  // In local dev, check if backend URL is available in env
  if (isLocalDev && process.env.REACT_APP_BACKEND_URL) {
    return process.env.REACT_APP_BACKEND_URL + '/api';
  }
  
  // In preview environment, also use the env variable if available
  if (isPreview && process.env.REACT_APP_BACKEND_URL) {
    return process.env.REACT_APP_BACKEND_URL + '/api';
  }
  
  // In production (atom-group.ch), use relative /api (proxied by Kubernetes)
  return '/api';
})();

// Full API URL with protocol for absolute URLs if needed
export const getFullApiUrl = () => {
  if (typeof window !== 'undefined') {
    if (API_BASE_URL.startsWith('http')) {
      return API_BASE_URL;
    }
    return `${window.location.origin}${API_BASE_URL}`;
  }
  return '/api';
};

// Helper to check if API is accessible
export const checkApiHealth = async () => {
  try {
    const healthUrl = API_BASE_URL.startsWith('http') 
      ? `${API_BASE_URL.replace('/api', '')}/health`
      : '/health';
    
    const response = await fetch(healthUrl);
    if (response.ok) {
      const data = await response.json();
      console.log('✅ API Health Check:', data);
      return true;
    }
    console.error('❌ API Health Check Failed:', response.status);
    return false;
  } catch (error) {
    console.error('❌ API Not Reachable:', error.message);
    return false;
  }
};

console.log('🔧 Environment:', isLocalDev ? 'Local Dev' : (isPreview ? 'Preview' : 'Production'));
console.log('🔗 API_BASE_URL =', API_BASE_URL);

export default API_BASE_URL;
